<div class="flex flex-col mt-4">
  <ion-label
    class="text-[13px] font-semibold pl-4 mb-2"
    [color]="color"
    >{{ input.label | translate }}</ion-label
  >
  <!-- Input Select -->
  <div
    *ngIf="input.type === 'select' && !isWeb"
    class="input-height bg-[#F5FAFD] rounded-[10px] flex justify-between items-center relative pr-7 pl-5"
    [ngClass]="{'opacity-50 pointer-events-none': input.disabled}"
  >
    <ion-select
      #selectInput
      [placeholder]="input.placeholder | translate"
      mode="ios"
      toggleIcon=""
      cancelText="Cancelar"
      okText="Seleccionar"
      [interface]="interface"
      [value]="selectedValue"
      [disabled]="input.disabled"
      (ionChange)="onSelectChange($event)"
    >
      <ion-select-option
        *ngFor="let option of input.options"
        [value]="option.value"
        >{{ option.label | translate }}</ion-select-option
      >
    </ion-select>
    <ion-icon
      src="../../../assets/svg/arrowDown.svg"
      class="absolute right-5 text-[17px]"
      color="primary"
    ></ion-icon>
  </div>
  <app-select-web
    *ngIf="isWeb && input.type === 'select'"
    [input]="input"
    [value]="selectedValue"
    [disabled]="input.disabled"
    (valueChange)="onSelectChange($event)"
  ></app-select-web>

  <!-- View Map -->
  <div
    *ngIf="input.type === 'map'"
    class="bg-[#F5FAFD] rounded-[10px] flex justify-between items-center relative px-5"
    style="min-height: 50px;"
    (click)="openMap()"
  >
    <ion-label class="text-[13px]" [ngClass]="{'text-[#ADBED7]': !selectedValue}">
      {{ selectedValue || (input.placeholder | translate) }}
    </ion-label>
    <ion-icon
      src="../../../assets/svg/location.svg"
      class="text-[17px]"
      color="primary"
    ></ion-icon>
  </div>
  <!-- Select Date -->
  <div
    *ngIf="input.type === 'date'"
    (click)="showCalendar()"
    class="input-height bg-[#F5FAFD] rounded-[10px] flex justify-between items-center relative px-5"
  >
    <ion-label class="text-[13px]" [ngClass]="{'text-[#ADBED7]': !selectedDate}">
      {{ selectedDate || (input.placeholder | translate) }}
    </ion-label>
    <ion-icon
      src="../../../assets/svg/calendar.svg"
      class="absolute right-5 text-[17px]"
      color="primary"
    ></ion-icon>
  </div>

  <!-- Autocomplete City -->
  <div *ngIf="input.type === 'autocomplete'" class="relative">
    <div class="input-height bg-[#F5FAFD] rounded-[10px] flex items-center relative px-5">
      <ion-input
        [placeholder]="input.placeholder | translate"
        [value]="autocompleteQuery"
        (ionInput)="onCityInputChange($event)"
        (ionBlur)="hideSuggestions()"
        class="text-[13px] w-full"
        maxlength="80"
      ></ion-input>
    </div>
    <div *ngIf="showCitySuggestions" class="absolute z-50 left-0 right-0 bg-white shadow-md rounded-md mt-1 max-h-60 overflow-auto border border-gray-200">
      <ion-list class="m-0 p-0">
        <ion-item button detail="false" lines="none" *ngFor="let s of citySuggestions" (click)="selectCitySuggestion(s)">
          <ion-label class="text-[13px] leading-tight">
            <div class="font-medium">{{ s.mainText }}</div>
            <div class="text-[11px] opacity-70" *ngIf="s.secondaryText">{{ s.secondaryText }}</div>
          </ion-label>
        </ion-item>
      </ion-list>
    </div>
  </div>
</div>

<ion-modal
  [keepContentsMounted]="true"
  #calendar
>
  <ng-template>
    <ion-datetime
      id="datetime"
      mode="ios"
      [showDefaultButtons]="true"
      [value]="tempDate"
      (ionChange)="onDateChange($event)"
    ></ion-datetime>
  </ng-template>
</ion-modal>
